import { Command } from 'ckeditor5/src/core';

export default class FileListCommand extends Command {
  execute( options = {} ) {
    const editor = this.editor;
    const model = editor.model;
    const selection = model.document.selection;
    const element = options.element;

    if ( element ) {
      if ( element._type.substring( 0, 6 ) === 'image/' ) {
        model.change( writer => {
          const imageElement = writer.createElement( 'imageBlock', {
            src: element._url
          } );
          model.insertContent( imageElement, selection );
        } );
      }
      else {
        model.change( writer => {
          const fileElement = writer.createText( element.label, {
            linkHref: element._url
          } );
          model.insertContent( fileElement, selection );
        } );
      }
    }
  }
}
